import { createRoute, redirect } from '@tanstack/react-router';

import { clientRoute } from '../route';

import { nebankaProductsRoute } from './NebankaProductsPage/route';

export const nebankaOldRoute = createRoute({
	path: '/nebanka/',
	getParentRoute: () => clientRoute,

	// Redirecting old bookmarked/copied links to new page
	beforeLoad: async ({ params }) => {
		throw redirect({
			to: nebankaProductsRoute.fullPath,
			replace: true,
			params,
		});
	},
});
